/**
 * Ghi chú - thiết lập quy tắc hạch toán đồng thời
 */
export default {
    Record: -1,
    Positive: 1,
};